
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Alert, Spin } from 'antd';
import { RootState } from '@share/utils';
import { ILoginState, IPasswordState, change } from '@share/store/slices';
import { Loading } from '@share/components';
import { BlueButton } from '@share/components';

import './style.scss';
import { ChangePasswordAshevillePlay } from '../change-password-ashevilleplay/component';


interface IProps {
  hideTitle?: boolean;
  horizontal?: boolean;
}

export function ChangePassword(props: IProps) {

  const passwordStore: IPasswordState = useSelector((state: RootState) => state.passwordStore);
  const loginStore: ILoginState = useSelector((state: RootState) => state.loginStore);

  const [ form ] = Form.useForm();

  const intl = useIntl();

  const dispatch = useDispatch();

  const { hideTitle, horizontal } = props;
  const { isSuccess, message, loading } = passwordStore;
  const { account } = loginStore;

  const onFinish = (values: any) => {
    dispatch(change(values.current, values.password, true));

    form.resetFields();
  };

  const mainBorderRadius = account?.mainBorderRadius;
  const isAshevillePlay = account?.isAshevillePlay;
  
  if (isAshevillePlay) {
    return <ChangePasswordAshevillePlay />;
  }

  return (
    <div className="password-page">

      {!hideTitle  && (
        <div className="password-page__header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-1 buttons" style={{ paddingRight: '0', position: 'relative' }}>
                <div className="password-page__title">
                  <h1><FormattedMessage id="change.password" /></h1>
                </div>
              </div>
            </div>
          </div>
        </div>)}

      <Spin spinning={loading} indicator={<Loading />} >
        <div className={`row form-profile ${horizontal ? 'horizontal-row' : ''}`}>
          <div className="col-sm-12">
            <Form
              name="normal_password"
              layout={horizontal ? 'horizontal' : 'vertical'}
              form={form}
              onFinish={onFinish}
              className={mainBorderRadius === '0' ? 'no-border' : ''}
            >
              <Form.Item>
                <div className="row">
                  <div className="col-sm-12 change-passowrd-row">
                    <Form.Item
                      name="current"
                      label={<FormattedMessage id="current.password" />}
                      rules={[{ required: true, message: <FormattedMessage id="enter.your.password" /> }]}
                      hasFeedback
                    >
                      <Input.Password />
                    </Form.Item>
                  </div>
                </div>
              </Form.Item>

              <Form.Item>
                <div className="row">
                  <div className="col-sm-12 change-passowrd-row">
                    <Form.Item
                      name="password"
                      label={<FormattedMessage id="new.password" />}
                      rules={[
                        { required: true, message: <FormattedMessage id="enter.new.password" />},
                        { min: 5, message: <FormattedMessage id="password.must.be.minimum.characters" /> }
                      ]}
                      hasFeedback
                    >
                      <Input.Password />
                    </Form.Item>
                  </div>
                </div>
              </Form.Item>

              <Form.Item>
                <div className="row">
                  <div className="col-sm-12 change-passowrd-row">
                    <Form.Item
                      name="confirm"
                      label={<FormattedMessage id="confirm.new.password" />}
                      dependencies={['password']}
                      hasFeedback
                      rules={[{ required: true, message: <FormattedMessage id="please.confirm.your.password" />},
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(intl.formatMessage({ id: 'the.two.passwords.that.you.entered.do.not.match' })));
                        },
                      }),
                      ]}
                    >
                      <Input.Password />
                    </Form.Item>
                  </div>
                </div>
              </Form.Item>

              <Form.Item>
                <div className="row">
                  <div className="col-sm-12">
                    <Form.Item>
                      <BlueButton block size='large' type="primary" htmlType="submit" disabled={loading}>
                        {loading ? <Spin size="small" style={{ marginRight: '10px' }} /> : null}
                        <FormattedMessage id="save.changes" />
                      </BlueButton>
                    </Form.Item>
                  </div>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Spin>

      {message && !loading ?
        <div className="row col-sm-12 pt-4" style={{ margin: 'auto' }}>
          {isSuccess
            ? <Alert message="" description={message} type="success" showIcon />
            : <Alert message="" description={message} type="error" showIcon />
          }
        </div>
        : null
      }
    </div>
  );
}
